// extracted by mini-css-extract-plugin
export default {"container":"_GcXgjAfoDxf6Ja1yYSu","challengeImage":"Y6iPmAZjyZw2BL_UDDOr","infoSection":"cmit9p2v_9OUick8tCEJ","rightColumn":"LiJ5k8Pd5iPpJPRmUJjY","buttons":"htq3Xxu9olWvsDvxMwJj"};